import request from 'configuration/request';

export const stockApi = {
  getList: () => {
    return request({
      url: '/stock/list/',
      method: 'GET',
    });
  },
};
